import { useToast } from "@mallardbay/lib-react-components"

import { useOutfitterContext } from "~contexts/outfitter-provider"
import { SelfOnboardingStepType } from "~graphql/generated/types"
import { useUpdateSelfOnboardingStepMutation } from "~graphql/outfitters.generated"
import { useLogOutfitterSelfOnboardingEvent } from "~utils/hooks/use-log-outfitter-self-onboarding-event"

export function useUpdateSelfOnboardingStep() {
    const { outfitter } = useOutfitterContext()
    const { showError } = useToast()
    const { logSelfOnboardingCompleted } = useLogOutfitterSelfOnboardingEvent()

    const [updateStepMutation, { loading: isLoading }] =
        useUpdateSelfOnboardingStepMutation({
            onError: showError,
        })

    const updateSelfOnboardingStep = async ({
        step,
        onSuccess,
    }: {
        step: SelfOnboardingStepType
        onSuccess?: () => void
    }) => {
        // outfitter may not be loaded yet since we are fetching it from apollo cache
        if (!outfitter) return

        await updateStepMutation({
            variables: { id: outfitter.id, step },
            onCompleted: () => {
                // Always log completion when the flow is finished, including
                // skip paths that jump straight to the finished step
                if (step === SelfOnboardingStepType.FinishedV2) {
                    logSelfOnboardingCompleted()
                }
                onSuccess?.()
            },
        })
    }

    return { updateSelfOnboardingStep, isLoading }
}
